import { isHotpads, isZillow } from '@zg-rentals/multibrand-support';
import StringConstants from '../constants/StringConstants';

export default (brandName: string): string => {
  if (isZillow(brandName)) {
    return StringConstants.ZILLOW_INBOX_PAGE_HEAD_TITLE;
  } else if (isHotpads(brandName)) {
    return StringConstants.HOTPADS_INBOX_PAGE_HEAD_TITLE;
  } else {
    return StringConstants.INBOX_PAGE_HEAD_TITLE;
  }
};
